import { FC } from 'react'
import LogoSvg from '../../../public/images/common/logo.svg'

export const Logo: FC = () => {
  return <LogoSvg />
}
